/**
 *
 * @param params - {
 *   key: string
 *   value: string
 *   prefix?: string
 * }
 * @returns {*} - banner options
 */
export default function(params) {
  return params.reduce((acc, item) => {
    return item
      ? Object.assign(acc, { [`${item.key}`]: [`${item.prefix || item.key}_${item.value}`] })
      : acc;
  }, {});
}
